import { Link, useParams } from "react-router-dom";
import HonariButton from "../Button/HonariButton";
import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { toast } from "react-toastify";
import Select from "react-select";
import Loading from "../Loading/Loading";

export default function CategoryPacks() {
  const id = useParams().id;
  const [data, setData] = useState(undefined);
  const [categoryList, setCategoryList] = useState(undefined);
  const [category, setCategory] = useState(undefined);
  const [selected, setSelected] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getData();
  }, [category]);

  useEffect(() => {
    getCategoryList();
  }, []);
  
  useEffect(() => {
    renderDataTable();
  }, [data]);

  const getCategoryList=()=>{
    const url = Constants.apiUrl + "/api/category/list";
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setCategoryList(r.data.data); 

        const categoryOptions = r.data.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
       
      setOptions(categoryOptions)
        
      })
      .catch((e) => {});
  }

  function getData(status=-1) {
    setLoading(true);
    const url = Constants.apiUrl + "/api/category/packs/" + category+"?status="+status;
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setData(r.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  const renderDataTable = () => {
    if (!data) return;
    let json = [];
    let ids = [];
    data.data.map((product) => {
      let packs = [];
      product.pack.map((pack) => {
        packs.push({
          id: pack.id,
          count: pack.count,
          barCode: pack.barCode,
          main: pack.main,
          label: pack.label,
          buy_price: pack.buy_price,
          price: pack.price,
          status: pack.status,
          percentage: pack.contractual_percentage,
          stock: pack.stock,
          new: false,
          base_price: pack.price,
          verbPrice: renderVerbPrice(pack),
          packingPrice: renderPackingPrice(pack),
          profit: renderProfit(pack, product),
        });
        ids.push(pack.id);
      });
      let productData = {
        id: product.id,
        status: product.prodStatus,
        name: product.prodName_fa,
        packaging_cost: product.info ? product?.info?.packaging_cost : 0,
        shipping_cost: product.info ? product?.info?.shipping_cost : 0,
        buyPrice: product.buyPrice ,
        url: product.url, 
        packs: packs,
      };
      json.push(productData);
    });
    setDataTable(json);
    setSelected(ids);
  };
  function checkSelected(packId) {
    return selected.includes(packId);
  }
  function selectedHandle(packId) {
    if (checkSelected(packId)) {
      const updatedIds = selected.filter((id) => id !== packId);
      setSelected(updatedIds);
    } else {
      const updatedIds = [...selected, packId];
      setSelected(updatedIds);
    }
  }
  const handleInputChange = (productId, packId, field, value) => {
    const updatedDataTable = dataTable.map((product) => {
      if (product.id === productId) {
        const updatedPacks = product.packs.map((pack) => {
          if (pack.id === packId) {
            // Update the pack field
            return { ...pack, [field]: value };
          }
          return pack;
        });

        return { ...product, packs: updatedPacks };
      }
      return product;
    });

    setDataTable(updatedDataTable); // Update the state
  };
  const handleGroupInputChange = (field, value) => {
    const updatedDataTable = dataTable.map((product) => {
      const updatedPacks = product.packs.map((pack) => {
        if (checkSelected(pack.id)) {
          return { ...pack, [field]: value };
        }
        return pack;
      });
      return { ...product, packs: updatedPacks };
    });

    setDataTable(updatedDataTable); // Update the state
  };
  const handlePriceOffer = () => {
    const updatedDataTable = dataTable.map((product) => {
      const updatedPacks = product.packs.map((pack) => {
        if (checkSelected(pack.id)) {
          let sellPrice =
            (product.buyPrice +
              product.shipping_cost +
              (data.orderCost.price + pack.verbPrice + pack.packingPrice) /
                pack.count) /
            (1 - pack.percentage / 100);
          sellPrice =
            sellPrice > 200
              ? Math.ceil(sellPrice / 100) * 100
              : Math.ceil(sellPrice);

          return {
            ...pack,
            base_price: isNaN(sellPrice) ? "0" : sellPrice,
            price: isNaN(sellPrice) ? "0" : sellPrice * pack.count,
          };
        }
        return pack;
      });
      return { ...product, packs: updatedPacks };
    });

    setDataTable(updatedDataTable); // Update the state
  };
  const handlePercentageOffer = () => {
    const updatedDataTable = dataTable.map((product) => {
      const updatedPacks = product.packs.map((pack) => {
        if (checkSelected(pack.id)) {
          const percentageValue =
            ((pack.base_price -
              (product.buyPrice +
                product.shipping_cost +
                (data.orderCost.price + pack.verbPrice + pack.packingPrice) /
                  pack.count)) /
              pack.base_price) *
            100;

          return {
            ...pack,
            percentage: isNaN(percentageValue)
              ? ""
              : Math.ceil(percentageValue),
          };
        }
        return pack;
      });
      return { ...product, packs: updatedPacks };
    });

    setDataTable(updatedDataTable); // Update the state
  };
  const addNewPack = (productId) => {
    const updatedDataTable = dataTable.map((product) => {
      if (product.id === productId) {
        const newPack = {
          id: Date.now(),
          label: "",
          count: 0,
          buy_price: 0,
          price: 0,
          base_price: 0,
          stock: 0,
          profit: 0,
          main: false,
          barCode: "بسته جدید",
          status: 0,
          new: true,
          percentage: 0,
        };

        return {
          ...product,
          packs: [newPack, ...product.packs], // اضافه کردن `pack` جدید به ابتدای لیست
        };
      }
      return product;
    });

    setDataTable(updatedDataTable); // به روزرسانی state
  };
  const removePack = (productId, packId) => {
    const updatedDataTable = dataTable.map((product) => {
      if (product.id === productId) {
        // فیلتر کردن بسته‌های غیر از بسته‌ای که باید حذف شود
        const updatedPacks = product.packs.filter((pack) => pack.id !== packId);

        return {
          ...product,
          packs: updatedPacks, // به‌روزرسانی لیست بسته‌ها
        };
      }
      return product;
    });

    setDataTable(updatedDataTable); // به‌روزرسانی state
  };
  const renderPackingPrice = (pack) => {
    let sum = 0;
    pack.pack_items &&
      pack.pack_items.map((item) => {
        sum += item.product.buyPrice * item.count;
      });
    return sum;
  };
  const renderVerbPrice = (pack) => {
    let sum = 0;
    pack.verbs &&
      pack.verbs.map((item) => {
        sum += item.price;
      });
    return sum * data.verbUnit.value;
  };
  const renderProfit = (pack, product) => {
    let sum =
      (pack.base_price * pack.count -
        ((product.buyPrice +
          (product.info?.shipping_cost ?? 0)) *
          pack.count +
          renderVerbPrice(pack) +
          renderPackingPrice(pack) +
          data.orderCost.price)) /
      1000;
    sum = Math.ceil(sum * 10) / 10;
    return sum;
  };
  const handleUpdateProfit = () => {
    const updatedDataTable = dataTable.map((product) => {
      const updatedPacks = product.packs.map((pack) => {
        if (checkSelected(pack.id)) {
          let profit =
            (pack.base_price * pack.count -
              ((product.buyPrice + product.shipping_cost) * pack.count +
                pack.verbPrice +
                pack.packingPrice +
                data.orderCost.price)) /
            1000;
          profit = Math.ceil(profit * 10) / 10;

          return {
            ...pack,
            profit: isNaN(profit) ? "" : Math.ceil(profit),
          };
        }
        return pack;
      });
      return { ...product, packs: updatedPacks };
    });

    setDataTable(updatedDataTable); // Update the state
  };
  async function submitHandle() {
    if (loading) return;

    const url = Constants.apiUrl + "/api/newPrefactor/packs/save";
    setLoading(true); // مقدار loading را true می‌کنیم.

    try {
      // ارسال درخواست به سرور
      const response = await axios.post(
        url,
        { products: dataTable },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      );

      toast.success("با موفقیت اعمال شد");
      getData();
    } catch (error) {
      toast.error("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
    } finally {
      setLoading(false); // بازگرداندن مقدار loading به false
    }
  }
  const changeFilterHandler =(e)=>{
    getData(e.target.value)
  }
  return (
    <>
      <Breadcrumb title={"ویرایش بسته ها"} />
      <div className="border rounded-lg py-5 px-3 mb-5 text-right"  >
        <label className="text-right">دسته بندی</label>
        <Select
                options={options} 
                isSearchable 
                onChange={(e)=>{setCategory(e.value)}}
             /> 
        </div>
        {
            loading && <Loading />
        }
        

{ category &&
<div>
      <div className="border rounded p-2 flex gap-x-2 items-center">
        <label>فیلتر</label>
        <div>
          <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 " onChange={changeFilterHandler}>
            <option value={-1}>نمایش همه</option>
            <option value={0}>نمایش بسته های غیرفعال</option>
            <option value={1}>نمایش بسته های فعال</option>
          </select>
        </div>
      </div>

      <div class="relative overflow-x-auto shadow-md sm:rounded-lg whitespace-nowrap " style={{height:"700px"}} >
        <table class="w-full text-sm text-center  text-gray-500 relative">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50  sticky top-0 left-0">
            <tr>
              <th scope="col" class="p-4"></th>
              <th scope="col" class="px-6 py-3">
                بارکد / نام محصول
              </th>
              <th scope="col" class="px-6 py-3">
                لیبل بسته
              </th>
              <th scope="col" class="px-6 py-3">
                تعداد
              </th>
              <th scope="col" class="px-6 py-3">
                قیمت بهای تمام شده
              </th>
              <th scope="col" class="px-6 py-3">
                قیمت واحد
              </th>
              <th scope="col" class="px-6 py-3">
                موجودی
              </th>
              <th scope="col" class="px-6 py-3">
                درصد
              </th>{" "}
              <th scope="col" class="px-6 py-3">
                فعال
              </th>
            
              <th scope="col" class="px-6 py-3">
                سود
              </th>
            </tr>
            <tr>
              <th scope="col" class="p-4">
                <div class="flex items-center">
                  <span>اعمال گروهی</span>
                </div>
              </th>
              <th scope="col" class="px-6 py-3"></th>
              <th scope="col" class="px-6 py-3">
                <input
                  type="text"
                  onChange={(e) => {
                    handleGroupInputChange("label", e.target.value);
                  }}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                />
              </th>
              <th scope="col" class="px-6 py-3">
                <input
                  type="text"
                  onChange={(e) => {
                    handleGroupInputChange("count", e.target.value);
                  }}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                />
              </th>
              <th scope="col" class="px-6 py-3">
                <div className=" flex flex-col">
                  <span title="خرید واحد" className="text-green-500">
                    "خرید واحد"
                  </span>
                  <span title="خرید کل" className="text-indigo-500">
                    "خرید کل"
                  </span>
                  <span title="هزینه ارسال" className="text-blue-500">
                    "هزینه ارسال"
                  </span>
                  <span title="هزینه افعال" className="text-pink-500">
                    هزینه افعال
                  </span>
                  <span title="هزینه بسته بندی" className="text-yellow-500">
                    هزینه بسته بندی
                  </span>
                </div>
              </th>
              <th scope="col" class="px-6 py-3 flex flex-col gap-y-2">
                <input
                  type="text"
                  onChange={(e) => {
                    handleGroupInputChange("base_price", e.target.value);
                  }}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                />
                <HonariButton onClick={handlePriceOffer}>پیشنهاد</HonariButton>
              </th>
              <th scope="col" class="px-6 py-3"></th>
              <th scope="col" class="px-6 py-3 flex flex-col gap-y-2">
                <input
                  type="text"
                  onChange={(e) => {
                    handleGroupInputChange("percentage", e.target.value);
                  }}
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                />
                <HonariButton onClick={handlePercentageOffer}>
                  پیشنهاد
                </HonariButton>
              </th>{" "}
              <th scope="col" class="px-6 py-3">
                <input
                  onChange={(e) => {
                    handleGroupInputChange("status", e.target.checked);
                  }}
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 "
                />
              </th>
               <th scope="col" class="px-6 py-3">
                <HonariButton onClick={handleUpdateProfit}>محاسبه</HonariButton>
              </th>
            </tr>
          </thead>
          <tbody>
            {dataTable &&
              dataTable.map((product) => (
                <>
                  <tr class="border-b bg-indigo-400 text-sm text-white font-bold">
                    <td scope="col" class="p-4">
                      {" "}
                    </td>
                    <td
                      scope="col"
                      class="px-6 py-3 max-w-lg"
                      style={{ display: "flex", whiteSpace: "normal" }}
                    >
                      {product.name}
                    </td>
                    <td scope="col" class="px-6 py-3">
                      <HonariButton
                        className={"border-0"}
                        onClick={() => addNewPack(product.id)}
                      >
                        بسته جدید
                      </HonariButton>
                    </td>
                    <td scope="col" class="px-6 py-3">
                      <a
                        target="_blank"
                        href={
                          Constants.oldAdminUrl + "/products/update/" +
                          product.id
                        }
                      >
                        <HonariButton className={"border-0"}>
                          ویرایش محصول
                        </HonariButton>
                      </a>
                    </td>
                    <td scope="col" class="px-6 py-3">
                      <a
                        target="_blank"
                        href={Constants.siteUrl + "/" + product.url}
                      >
                        <HonariButton className={"border-0"}>
                          مشاهده محصول
                        </HonariButton>
                      </a>
                    </td>
                    <td scope="col" class="px-6 py-3"></td>
                    <td scope="col" class="px-6 py-3"></td>
                    <td scope="col" class="px-6 py-3"></td>
                    <td scope="col" class="px-6 py-3"></td>
  
                    <td scope="col" class="px-6 py-3"></td>
                  </tr>
                  {product.packs.map((pack) => (
                    <>
                      <tr
                        className={`border-b text-xs ${
                          pack.main == 1
                            ? "hover:bg-green-100 bg-green-50 "
                            : "hover:bg-red-100 bg-red-50 "
                        } ${
                          pack.new == 1
                            ? "bg-yellow-50 hover:bg-yellow-100"
                            : ""
                        }`}
                      >
                        <td scope="col" class="p-4">
                          <div class="flex items-center">
                            <input
                              id="checkbox-all"
                              type="checkbox"
                              checked={checkSelected(pack.id)}
                              onChange={() => {
                                selectedHandle(pack.id);
                              }}
                              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 "
                            />
                            <label for="checkbox-all" class="sr-only">
                              checkbox
                            </label>
                          </div>
                        </td>
                        <td scope="col" class="px-6 py-3">
                          {pack.barCode}
                        </td>
                        <td scope="col" class="px-6 py-3">
                          <input
                            type="text"
                            id=""
                            value={pack.label}
                            onChange={(e) =>
                              handleInputChange(
                                product.id,
                                pack.id,
                                "label",
                                e.target.value
                              )
                            }
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-center "
                          />
                        </td>
                        <td scope="col" class="px-6 py-3">
                          <input
                            type="text"
                            id=""
                            value={pack.count}
                            onChange={(e) =>
                              handleInputChange(
                                product.id,
                                pack.id,
                                "count",
                                e.target.value
                              )
                            }
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-center"
                          />
                        </td>
                        <td scope="col" class="px-6 py-3">
                          <div className=" flex flex-col">
                            <span title="خرید واحد" className="text-green-500">
                              {product.buyPrice}
                            </span>
                            <span title="خرید کل" className="text-indigo-500">
                              {product.buyPrice * pack.count +
                                data.orderCost.price}
                            </span>
                            <span title="هزینه ارسال" className="text-blue-500">
                              {Math.ceil(product.shipping_cost * pack.count)}
                            </span>
                            <span title="هزینه افعال" className="text-pink-500">
                              {pack.verbPrice}
                            </span>
                            <span
                              title="هزینه بسته بندی"
                              className="text-yellow-500"
                            >
                              {pack.packingPrice}
                            </span>
                          </div>
                        </td>
                        <td scope="col" class="px-6 py-3">
                          <input
                            type="text"
                            id=""
                            value={pack.base_price}
                            onChange={(e) =>
                              handleInputChange(
                                product.id,
                                pack.id,
                                "base_price",
                                e.target.value
                              )
                            }
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-center"
                          />
                          <span className="text-green-500">
                            {Number(pack.base_price) * Number(pack.count)}
                          </span>
                        </td>
                        <td scope="col" class="px-6 py-3">
                          {pack.stock}
                        </td>
                        <td scope="col" class="px-6 py-3">
                          <input
                            type="text"
                            value={pack.percentage}
                            onChange={(e) =>
                              handleInputChange(
                                product.id,
                                pack.id,
                                "percentage",
                                e.target.value
                              )
                            }
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-center"
                          />
                        </td>{" "}
                        <td scope="col" class="px-6 py-3">
                          <input
                            id="checkbox-all"
                            checked={pack.status}
                            onChange={(e) =>
                              handleInputChange(
                                product.id,
                                pack.id,
                                "status",
                                e.target.checked ? 1 : 0
                              )
                            }
                            type="checkbox"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 "
                          />
                        </td>
                         <td scope="col" class="px-6 py-3">
                          {pack.new ? (
                            <HonariButton
                              onClick={() => {
                                removePack(product.id, pack.id);
                              }}
                            >
                              حذف
                            </HonariButton>
                          ) : (
                            <span
                              className={`${
                                pack.profit < 6 ? "text-red-500" : ""
                              }`}
                            >
                              {pack.profit}
                            </span>
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
                </>
              ))}
          </tbody>
        </table>
      </div>
      <HonariButton
        onClick={submitHandle}
        disabled={loading}
        className={`w-full mt-10 ${loading ? "opacity-50" : ""}`}
      >
        {loading ? "در حال اعمال تغییرات" : "ذخیره"}
      </HonariButton>
      </div>}
      
    </>
  );
}
